import { useAuthStore } from '@/store';
import axios from 'axios';
import { i18n } from '../plugins/i18n';

export const API_ORIGIN = localStorage.getItem('VUE_APP_EVENT_SERVER_ORIGIN');
export const BASE_AUTHENTICATED_API_URL = API_ORIGIN + '/api/v1';
export const BASE_PUBLIC_API_URL = API_ORIGIN + '/pbl/api/v1';

export const CORE_API_ORIGIN = localStorage.getItem(
  'VUE_APP_CORE_SERVER_ORIGIN',
);
export const BASE_CORE_API_URL = CORE_API_ORIGIN + '/api/v1';

const MERCHANT_ID = localStorage.getItem('MERCHANT_ID');
// Authorization header is inserted automatically to each request (if token is present)
export const authInterceptor = [
  (config) => {
    const authStore = useAuthStore();
    if (authStore.getToken()) {
      config.headers.Authorization = `Bearer ${authStore.getToken()}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
];

export const headersInterceptor = [
  (config) => {
    config.headers['Accept-language'] = i18n.global.locale;
    config.headers['MERCHANT-ID'] = MERCHANT_ID;

    return config;
  },
  (error) => Promise.reject(error),
];

export const AuthEPsService = (url) =>
  axios.create({
    baseURL: BASE_AUTHENTICATED_API_URL + url,
  });

export const PublicEPsService = (url) =>
  axios.create({
    baseURL: BASE_PUBLIC_API_URL + url,
  });

export const AuthorizedService = (url) => {
  const authorizedService = AuthEPsService(url);
  authorizedService.interceptors.request.use(...authInterceptor);
  authorizedService.interceptors.request.use(...headersInterceptor);
  return authorizedService;
};

export const PublicService = (url) => {
  const service = PublicEPsService(url);
  service.interceptors.request.use(...headersInterceptor);
  return service;
};

export const translationsService = async () => {
  try {
    return axios.get(`${BASE_PUBLIC_API_URL}/json-i18n`, {
      headers: {
        'MERCHANT-ID': MERCHANT_ID,
      },
    });
  } catch (error) {
    console.error('Error fetching translations:', error);
  }
};
